import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { FormRow } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { PasswordField } from "@src/components/ui-kit/password-input";
import { fieldToInputProps } from "@src/utils/forms/inputHelpers";
import { observer } from "mobx-react-lite";
import type { ChangeUserPasswordStore } from "./store";

type ModalChangeUserPasswordProps = {
  readonly store: ChangeUserPasswordStore;
};

export const ModalChangeUserPassword = observer(
  function ModalChangeUserPassword({ store }: ModalChangeUserPasswordProps) {
    const form = store.changePasswordForm;
    const user = store.disclosure.additionalData?.user;

    if (!form || !user) return null;

    return (
      <Modal
        isOpen={store.disclosure.isOpen}
        onClose={store.disclosure.onClose}
        trapFocus={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Trans>Change password for {user.full_name}</Trans>
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <FormRow title={<Trans>New password</Trans>}>
              <PasswordField
                id="field-user-new-password"
                {...fieldToInputProps(form.password)}
                placeholder={t`Enter new password`}
              />
            </FormRow>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="grey"
              isLoading={store.isChangePasswordLoading}
              onClick={store.disclosure.onClose}
              variant="outline"
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              ml="3"
              isDisabled={form.form.hasError}
              isLoading={store.isChangePasswordLoading}
              onClick={store.updateUserPassword}
            >
              <Trans>Update</Trans>
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  },
);
